export const serviceDetailEn = {
    zaixianxunjia:"Online inquiry",
    fuwubeijing:"Service background",
    fuwuneirong:"The service content",
    fuwuliucheng:"Service process",
    fuwupingjia:"service evaluation",
    jcrzfw:"Test certification service",
    nidehy:'Your industry:',
    hangye:'industry',
    leixing:'type',
    fuwu:'service',
    zxnr:'Consultation content:',
    qsruxcnr:'Please input your consultation content',
    xingming:'Full name:',
    qsrxm:'Please enter a name',
    shoujihm:'phone number:',
    wsrsjhm:'Please enter your mobile number',
    qsryx:'Please enter email',
    suozd:'Location:',
    sheng:'province',
    shi:'city',
    xian:'County / district',
    qiyemc:'Company name:',
    qsrqymc:'Please enter the enterprise name',
    quxiao:'cancel',
    xiayibu:'next',
    woyiyuedu:'I have read and agree',
    xieyi:'CCPIT product testing and certification platform agreement',
    jichuxx:'Basic information',
    qingsr:'Please input',
    fujianxz:'Attachment Download',
    jianche:'Test item information',
    wenjiansc:'File upload',
    tjfj:'Add attachments',
    tijiao:'Submission',
    tijiaocg:'Congratulations on the successful submission of your consultation information',
    naixinbaojia:'Please wait patiently for the platform quotation, you can go to my inquiry to see the details',
    fanhuisy:'Back to home page',
    quwodebaojiadang:'Go to my quotation (Note: Customer Center)',
    txzxxx:'Fill in consultation information',
    tjshengq:'Submit application materials',
    tijiaocg:'Submit successfully',
    zhonghe:'comprehensive',
    xiaoliang:'Sales volume',
    jiage:'Price',
    shangejia:'Shelf time',
    zwfw:'There is no standard service for this kind of service. Please get the relevant quotation information through "online inquiry". Thank you',
    zhanwupinglun: 'No comments'
}


// WEBPACK FOOTER //
// ./src/lang/home/serviceDetail/serviceDetailEn.js